const ALPHABET = "abcdefghijklmnopqrstuvwxyz";

export default ALPHABET;
